<template>
  <div class="addedprocessesform" @keyup.enter="submitForm">
    <b-modal :active.sync="addModalShowEvent" has-modal-card>
      <section class="modal-bg columns-no-p-m">
        
        
        <b-field>
          <div class="columns">
            <div
              v-if="findedCard && findedCard.comment"
              class="column"
            >
              {{ findedCard.comment }}
            </div>

            <div class="column">
              <strong v-if="findedCard" class="tag is-medium">{{findedCard.bonuses}} бонусів</strong>
            </div>
          </div>
        </b-field>
        <b-field label="Номер картки - імя">
          <div class="columns">
            <div class="column">
              <b-input
                @input="checkCardId"
                name="cardId"
                v-model="cardId"
                v-mask="'####'"
                placeholder="Номер картки"
              ></b-input>
            </div>
            <div class="column">
              <b-input v-model="name" placeholder="Имя" :readonly="findedCard"></b-input>
            </div>
          </div>
        </b-field>
        <b-field label="Номер телефону">
          <div class="columns">
            <div class="column">
              <b-input v-model="phone" placeholder="Номер телефона" :readonly="findedCard"></b-input>
            </div>
          </div>
        </b-field>

        <b-field label="Актуальна вага - заокруглена - вартість - пакетів">
          <div class="columns">
            <div class="column">
              <b-input @input="setWeightRounded" placeholder="Вага на вагах"></b-input>
            </div>
            <div class="column">
              <b-input
                v-model="weight_rounded"
                @input="setPriceFinish"
                placeholder="Заокруглена вага"
              ></b-input>
            </div>
            <div class="column">
              <b-input v-model="price_finish" placeholder="До оплати"></b-input>
            </div>
            <div class="column">
              <b-input v-model="number_of_packages" placeholder="Кількість пакетів"></b-input>
            </div>
          </div>
        </b-field>

        <b-field>
          <b-select placeholder="Виберіть послугу" @input="setPriceFinish" v-model="selected">
            <option
              v-for="(option, index) in services"
              :value="option"
              :key="index"
            >{{ option.name }}</option>
          </b-select>
        </b-field>

        <b-field>
          <b-select
            placeholder="Додаткова послуга"
            @input="setPriceFinish"
            v-model="additional_selected"
          >
            <option
              v-for="(option, index) in services"
              :value="option"
              :key="index"
            >{{ option.name }}</option>
          </b-select>
          <b-button style="margin-left: 10px;" @click="reset_additional" icon-left="close" />
        </b-field>

        <b-field>
          <div class="full-width-div">
            <b-dropdown class="has-text-black" position="is-top-right" hoverable aria-role="list">
              <button
                @click="createHundle({paid: 0})"
                class="pd-0-1 button is-success"
                slot="trigger"
              >
                <span>Не оплачено</span>
              </button>

              <b-dropdown-item aria-role="listitem" @click="createHundle({paid: 3})">Бонусами</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="createHundle({paid: 2})">Терминал</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="createHundle({paid: 1})">Готівкою</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-field>

        <b-field label="Коментар">
          <b-input v-model="description" type="textarea"></b-input>
        </b-field>

        <b-field v-if="!findedCard">
          <b-switch v-model="langSms" true-value="EN" false-value="UA">{{ langSms }}</b-switch>
        </b-field>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import * as dayjs from 'dayjs'
import debounce from "lodash.debounce";

import printing from "@/utils/printing.js";

export default {
  data() {
    return {
      selected: "",
      langSms: "UA",
      additional_selected: null,
      weight: "",
      weight_rounded: "",
      number_of_packages: 1,
      price_finish: "",
      cardId: "",
      name: "",
      phone: "",
      description: "",
      findedCard: null
    };
  },
  computed: {
    ...mapState(["services"]),
    addModalShowEvent: {
      get() {
        return true
      },

      set() {
        this.$emit("close");
      }
    }
  },
  methods: {
    ...mapActions(["getCards", "createProcesses", "editProcesses"]),
    printing,
    reset_additional() {
      this.additional_selected = null;
      this.setPriceFinish();
    },

    submitForm() {
      const inputs = document
        .getElementsByClassName("addedprocessesform")[0]
        .getElementsByTagName("input");
      let focus = null;
      for (let el of inputs) {
        if (el.value.length == 0 && el.name !== "cardId") {
          focus = el;
          break;
        }
      }
      if (focus) {
        focus.focus();
      } else {
        this.createHundle({ paid: 0 });
      }
    },
    setWeightRounded(val) {
      this.weight = Number(val.replace(",", "."));
      if (Number(this.weight) < 500) {
        const ceil = this.weight - Math.trunc(this.weight) > 0.5;
        this.weight_rounded = ceil
          ? Math.ceil(parseFloat(this.weight))
          : Math.trunc(this.weight);
      } else {
        this.weight_rounded = Math.ceil(parseFloat(this.weight / 1000));
      }
      this.setPriceFinish();
    },
    setPriceFinish() {
      if (!this.weight_rounded) return;

      let sum = 0;

      if (this.additional_selected && this.additional_selected.price) {
        sum += parseInt(this.weight_rounded) * Number(this.additional_selected.price);
      }

      if (this.selected) {
        if (this.selected.price) {
          sum += parseInt(this.weight_rounded) * Number(this.selected.price);
        }

        // Прання та сушіння
        if (this.selected.id === 6 && sum < 70) {
          sum = 80;
        }

        // Прання та сушіння
        if (this.selected.id === 6 && sum < 70) {
          sum = 80;
        }

        // Прання, сушіння та прасування
        if (this.selected.id === 20 && sum < 120) {
          sum = 120;
        }

        // Постільна білизна з прасуванням
        if (this.selected.id === 16 && sum < 90) {
          sum = 90;
        }

        // Плед, ковдра, наматрацник, подушка (кг)
        if (this.selected.id === 12 && sum < 120) {
          sum = 120;
        }
      }

      if (sum < 70) {
        sum = 80;
      }

      this.price_finish = sum;
    },
    checkCardId: debounce(async function debouncedInput($event) {
      this.findedCard = null;
      if ($event.length == 4) {
        await this.getCards({
          url: `cards/${$event}`
        })
          .then(result => {
            this.findedCard = result;
            this.name = result.name;
            this.phone = result.phone;
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              duration: 5000,
              message: "Пользователь не найден",
              position: "is-top"
            });
          });
      }
    }, 400),
    clearAll() {
      this.name = "";
      this.phone = "";
      this.findedCard = null;
      this.weight = "";
      this.weight_rounded = "";
      this.price_finish = "";
      this.cardId = "";
      this.description = "";
      this.additional_selected = null;
    },

    async createHundle({ paid = 0 }) {
      if (this.weight && this.weight_rounded && this.name && this.phone) {
        let data = {
          service_id: this.selected.id,
          weight: this.weight > 500 ? this.weight / 1000 : this.weight,
          paid: 0,
          parts: this.number_of_packages,
          moved: 0,
          created_at: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          rounded_weight: Number(this.weight_rounded),
          price: Number(this.price_finish),
          name: this.name,
          phone: this.phone,
          comment: this.description,
          additional_service_id: this.additional_selected
            ? this.additional_selected.id
            : null,
          done_at: dayjs(new Date()).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
        };

        if (!this.findedCard) data.en = this.langSms == "EN" ? 1 : 0;

        if (this.findedCard) data.card_id = `${this.cardId}`;

        await this.createProcesses(data).then(async res => {
          if (paid > 0) {
            await this.editProcesses({
              point: `processes/${res.id}/pay/${paid}`
            });
          }
          let service = this.services.find(({ id }) => id == res.service_id);
          let payment =
            paid == 1
              ? "Готівка"
              : paid == 2
              ? "Картка"
              : paid == 3
              ? "Бонуси"
              : null;
          await this.printing(
            res,
            service,
            payment,
            this.price_finish,
            this.additional_selected
          );
          window.print();
        });
        this.clearAll();
        this.$emit("refresh");
        this.$emit("close", false);
      } else {
        this.$buefy.snackbar.open({
          duration: 5000,
          message: "Не все поля заполнены!",
          position: "is-top"
        });
      }
    }
  },

  async mounted() {
    this.selected = this.services[0]
  }
};
</script>

<style lang="scss" scoped>
.pd-0-1 {
  margin: 1rem 0;
}
</style>

